export const EVENTS = {
    UPDATE_STATUS: "SETTINGS.UPDATE_STATUS",
    FETCH_PROJECT_INFO_AGAIN: "PROJECT.FETCH_AGAIN"
};
